import React from "react";
import styles from "./BubbleInfos.module.scss";
const BubbleInfos = ({ children }) => {
  return <div className={styles.bubbleInfos}>{children}</div>;
};

export default BubbleInfos;
